module.exports = __webpack_public_path__ + "static/media/contrato-imagen.4370c663.png";